import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useAlertPanelStyles = makeStyles<Theme, { severity: string }>(
  () => {
    const labelText = {
      fontSize: '0.875rem',
      fontStyle: 'normal',
      lineHeight: 'normal',
      fontWeight: 400,
    };

    const severityStyles: Record<
      string,
      {
        containerBackground: string;
        leftBorderBackground: string;
        titleColor: string;
        separatorColor: string;
        descColor: string;
      }
    > = {
      error: {
        containerBackground: '#FFF2F1',
        leftBorderBackground: '#D10000',
        titleColor: '#222222',
        separatorColor: '#FFA3A3',
        descColor: '#330000',
      },
      warning: {
        containerBackground: '#FFF8E1',
        leftBorderBackground: '#FFC300',
        titleColor: '#222222',
        separatorColor: '#FFC300',
        descColor: '#664E01',
      },
      success: {
        containerBackground: '#DFFBE5',
        leftBorderBackground: '#16B141',
        titleColor: '#222222',
        separatorColor: '#44E872',
        descColor: '#062D11',
      },
    };

    return {
      container: ({ severity }) => {
        const severityStyle = severityStyles[severity];

        return {
          display: 'flex',
          alignItems: 'flexStart',
          paddingRight: '0.75rem',
          gap: '0.75rem',
          borderRadius: '0.25rem',
          marginBottom: '0.75rem',
          background: severityStyle.containerBackground,

          '& .leftBorder': {
            width: '0.25rem',
            flexShrink: '0',
            alignSelf: 'stretch',
            background: severityStyle.leftBorderBackground,
          },

          '& .mainWrapper': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            flex: '1 0 0',

            '& .shortInfoWrapper': {
              display: 'flex',
              padding: '0.75rem 0',
              justifyContent: 'space-between',
              alignItems: 'center',
              alignSelf: 'stretch',

              '& .contentWrapper': {
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',

                '& .errorTitle': {
                  ...labelText,
                  color: severityStyle.titleColor,
                  fontWeight: 500,
                  lineHeight: '150%',
                },
                '& .separator': {
                  width: '1px',
                  height: '1.5rem',
                  background: severityStyle.separatorColor,
                },

                '& .showDetailsWrapper': {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.25rem',
                  cursor: 'pointer',

                  '& .showDetails': {
                    ...labelText,
                    color: severityStyle.titleColor,
                    lineHeight: '150%',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  },
                  '& .moreIcon': {
                    color: severityStyle.titleColor,
                  },
                },
              },
              '& .closeIcon': {
                color: '#333333',
                cursor: 'pointer',
              },
            },

            '& .detailsInfoWrapper': {
              display: 'flex',
              flexDirection: 'column',
              padding: '0.5rem 0',
              justifyContent: 'center',
              gap: '0.625rem',
              alignSelf: 'stretch',

              '& .detailsInfo': {
                ...labelText,
                lineHeight: '150%',
                color: severityStyle.descColor,

                '& a': {
                  color: 'inherit',
                },
              },
            },
          },
        };
      },
    };
  },
  { name: 'AlertPanel' },
);
